export default __webpack_public_path__ + "static/media/healthIns.e31275ff.jpg";